/**
 * Versionado del módulo de riesgos y oportunidades. Solo existen v1 y v2.
 * - Versión 1: antes de mayo 2026 (sin vulnerabilidad en cálculo, UI antigua).
 * - Versión 2: desde mayo 2026 en adelante (con vulnerabilidad, 4 niveles, etc.).
 *
 * El año/mes deben ser los del registro mostrado (risk_month/opportunity_month)
 * cargado con getRisk(rmId) / getOpportunity(omId). Las listas deben pasar rmId/omId.
 */

const CUTOFF_YEAR = 2026;
const CUTOFF_MONTH = 5;

/**
 * Devuelve el número de versión (1 o 2) según el año/mes del registro.
 * v2 desde marzo 2026 en adelante; antes de esa fecha es v1.
 * @param {number} year - Año del risk_month / opportunity_month
 * @param {number} month - Mes (1-12)
 * @returns {number} 1 o 2
 */
export const isRiskVersion = (year, month) => {
  if (year == null || month == null) return 1;
  const y = parseInt(year, 10);
  const m = parseInt(month, 10);
  if (y > CUTOFF_YEAR || (y === CUTOFF_YEAR && m >= CUTOFF_MONTH)) return 2;
  return 1;
};
